module.exports = __webpack_public_path__ + "static/img/to.ed0e1091.svg";